import { CreateWorkdayProjectCommand, WorkdayProjectType } from "app/ApiClient";
import * as Yup from "yup";

const REQUIRED_MESSAGE = "Field required";

export const CreateWorkdayProjectFormSchema = Yup.object({
  client: Yup.string().nullable(),
  costCenter: Yup.string().nullable(),
  name: Yup.string().required(REQUIRED_MESSAGE),
  workdayProjectType: Yup.string().required(REQUIRED_MESSAGE),
  workdayId: Yup.string().required(REQUIRED_MESSAGE),
}).defined();

export const initialCreateWorkdayProjectForm: CreateWorkdayProjectCommand = {
  client: "",
  costCenter: "",
  name: "",
  workdayId: "",
  workdayProjectType: undefined
};

export const projectTypes = [
  { id: WorkdayProjectType.Tracker, label: 'Tracker' },
  { id: WorkdayProjectType.Adhoc, label: 'Adhoc' },
];
